import { useEffect }                            from 'react';
import Select                                   from 'react-select';
import { Dialog, DialogBackdrop, DialogPanel }  from '@headlessui/react';
import { useForm, Controller }                  from "react-hook-form";
import '../../styles/LoadingTable.css'


function FarolTerminalForm({ 
    
    isOpen, 
    onClose, 
    onSubmit,

    isEditMode,
    formEditValues,
    errorMessage,

    isShipDockered,
    setShipDockered,
    
    isLoading,
    optionsTerminals,

}) {
    
    const { 

        control, 
        register,
        handleSubmit,
        setValue

    } = useForm();

    const setupEditMode = () => {

        const { terminalId, shipDescription, description, isShipDockered } = formEditValues

        const selectedOption = optionsTerminals?.find(opt => opt.value === terminalId)

        setValue("terminalId", selectedOption)
        setValue("shipDescription", shipDescription === '--' ? '' : shipDescription)
        setValue("description", description)
        setShipDockered(isShipDockered)

    }

    const setupCreateMode = () => {
        
        // Primeiro terminal ainda sem farol nesta publicação
        const firstOption = optionsTerminals.find(opt => !opt.isDisabled) ?? null
        setValue("terminalId",      firstOption)
        setValue("shipDescription", null)
        setValue("description",     null)
        setShipDockered(false)
    
    }

    useEffect(() => {

        (formEditValues && isEditMode) ? setupEditMode(): setupCreateMode()

    // optionsTerminals entra porque os terminais já usados chegam depois de o modal abrir
    }, [ isOpen, isEditMode, optionsTerminals ])
    
    
    return (

        <Dialog open={isOpen} onClose={onClose} onSubmit={onSubmit} className="relative z-[100]">

        <DialogBackdrop transition className="fixed inset-0 bg-bg-backdrop transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"/>
        
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                
                <DialogPanel transition className="w-[808px] relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8  data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95">   
                    
                    <div className="app-container">
                        
                        <header className="bg-azul-profundo-m flex justify-between items-center pl-4 pr-1 py-3">
                            
                            <h2 className="text-white text-[1rem] leading-7 font-semibold">{!isEditMode ? "Novo " : "Editar "}Farol de Terminais</h2>
                            <button onClick={onClose} className="text-[1.2rem] text-white hover:text-gray-200 pr-2 ">×</button>
                            
                        </header>

                        {/* Inputs */}
                        <div className="px-4 pb-4 pt-5 sm:p-6 sm:pb-4 flex flex-col gap-[10px]">
                            

                            <>{isLoading ? (

                                <div className="flex flex-col w-full">

                                    <span className="text-sm font-semibold">Terminal:</span>
                                    <div className='one h-[38px] w-full border-[solid] border-[1px] border[#5e5e5e] rounded-[6px]'></div>
                                </div>

                            ) : (
                                
                                //{/* Terminal */}
                                <div className="flex flex-col w-full">
                                    
                                    <span className="text-sm font-semibold">Terminal:</span>
                                    
                                    <Controller
                                        control={control}
                                        name="terminalId"
                                        rules={{ required: false }}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={optionsTerminals}
                                                classNamePrefix="select"
                                                
                                            />
                                        )}
                                    />
                                </div>

                            )}
                            
                            </>

                            {/* Ship Dockered */}
                            <div className="flex flex-col w-full">
                                
                                <span className="text-sm font-semibold">Navio atracado:</span>
                                
                                <div className=" sm:grid-cols-2 gap-2 w-full flex">
                                    
                                <div className="grid sm:grid-cols-2 gap-2 w-full">
                                    
                                    <label 
                                        htmlFor="hs-radio-on-right" 
                                        className="flex p-3 w-full bg-white border border-gray-300 rounded-[3px] text-sm focus:border-blue-500 focus:ring-blue-500  "
                                    >
                                        <div className="text-sm text-gray-500 ">Sim</div>
                                        
                                        <input 
                                            type="radio" 
                                            value="true"
                                            name="shipDocked"
                                            checked={isShipDockered === true}
                                            className="shrink-0 ms-auto mt-0.5 border-gray-200 rounded-full text-blue-600 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none !block ![appearance:auto]" 
                                            id="hs-radio-on-right" 
                                            onChange={() => setShipDockered(!isShipDockered)}
                                        />

                                    </label>

                                    <label 
                                        htmlFor="hs-radio-on-right-checked" 
                                        className="flex p-3 w-full bg-white border border-gray-300 rounded-[3px] text-sm focus:border-blue-500 focus:ring-blue-500  "
                                    >
                                        <div className="text-sm text-gray-500">Não</div>
                                        <input 
                                            type="radio" 
                                            name="shipDocked"
                                            value="false"
                                            checked={isShipDockered === false}
                                            className="shrink-0 ms-auto mt-0.5 border-gray-200 rounded-full text-blue-600 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none !block ![appearance:auto]" 
                                            id="hs-radio-on-right-checked" 
                                            onChange={() => setShipDockered(!isShipDockered)}
                                        />
                                    </label>

                                </div>
                                </div>
                            
                            </div>

                            {/* Ship Description */}    
                            <div className="flex flex-col w-full">
                                <span className="text-sm font-semibold">Informações do Navio:</span>
                                <input 
                                    type="text" 
                                    {...register("shipDescription", { required: false })}
                                    className="border border-gray-300 rounded-[3px] px-3 py-2 focus:outline-none focus:border-blue-500"
                                />
                            </div>

                            {/* Description */}            
                            <div className="flex flex-col mb-4">
                                
                                <span className="text-sm font-semibold">Descrição:</span>      
                                
                                <textarea 
                                
                                    id="multiLineInput" 
                                    rows="5" 
                                    className="border border-gray-300 rounded-[3px] px-3 py-2 focus:outline-none focus:border-blue-500 blue-scrollbar" 
                                    placeholder="Escreva aqui..." 
                                    {...register("description", { required: false })}
                                
                                />

                            </div>

                            {/* Error Message */}
                            {errorMessage && (
                                <div className="text-red-500 text-sm mb-4 border-[red] border-[1px] px-4 py-3 rounded-[5px] bg-[#ffb0b08a]">{errorMessage}</div>
                            )}
                            
                        </div>
                        

                        {/* Buttons */}
                        <div className="w-full bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                            
                            <button 
                                type="submit" 
                                onClick={handleSubmit(onSubmit)} 
                                className="btn btn-azul-prof sm:ml-3 w-[50%] text-[1.125rem]"
                            >
                                Salvar
                            </button>

                            <button 
                                type="button" 
                                onClick={onClose} 
                                className="btn btn-cinza w-[50%] text-[1.125rem]"
                            >
                                Cancelar
                            </button>

                        </div>
                        
                    </div>
                </DialogPanel>
            </div>

        </div>
        
        </Dialog>
    );
}


export default FarolTerminalForm ;